import layout1 from './layout1/Layout1Config';
import layout2 from './layout2/Layout2Config';
import layout3 from './layout3/Layout3Config';
import i18next from 'i18next';
import en from './shared-components/i18n/en';
import jp from './shared-components/i18n/jp';

i18next.addResourceBundle('en', 'sharedComponentsPage', en);
i18next.addResourceBundle('jp', 'sharedComponentsPage', jp);

const FuseLayoutConfigs = {
	layout1,
	layout2,
	layout3,
};



export default FuseLayoutConfigs;
